
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SidebarCollapsible',
  data() {
    return {
      collapsed: false
    }
  },
  props: {
    title: { type: String, default: '' },
    icon: {
      type: String,
      default: 'star-filled'
    }
  }
})
